import { render, staticRenderFns } from "./Buzon.vue?vue&type=template&id=65fe8ec3"
import script from "./Buzon.vue?vue&type=script&lang=js"
export * from "./Buzon.vue?vue&type=script&lang=js"
import style0 from "./Buzon.vue?vue&type=style&index=0&id=65fe8ec3&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports